module.exports = __webpack_public_path__ + "media/img/event/speakers/Dr-Sajid-Nisar-e72397528ad1ad3466d3f3fff0dc86a0.jpg";